var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Bar',{attrs:{"data":_vm.data,"options":_vm.mergedOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }